import { render, staticRenderFns } from "./TrekkingVoucherPrint.vue?vue&type=template&id=0fbacf74&scoped=true&"
import script from "./TrekkingVoucherPrint.vue?vue&type=script&lang=js&"
export * from "./TrekkingVoucherPrint.vue?vue&type=script&lang=js&"
import style0 from "./TrekkingVoucherPrint.vue?vue&type=style&index=0&id=0fbacf74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbacf74",
  null
  
)

export default component.exports